import { Link } from "react-router-dom";
import { getCategoryPreset, CATEGORY_ORDER } from "../lib/categoryConfig";

// Demo routes and descriptions per category
const DEMO_META = {
  hair: { demo: "/hair", word: "hair" },
  nails: { demo: "/nails", word: "nail" },
  makeup: { demo: "/mua", word: "makeup" },
  lashes: { demo: "/lash", word: "lash" },
  wellness: { demo: "/wellness", word: "wellness" },
  culinary: { demo: "/culinary", word: "culinary" },
  retail: { demo: "/retail", word: "style" },
  instructors: { demo: "/instructor", word: "instructor" },
  events: { demo: "/events", word: "event" },
  travel: { demo: "/travel", word: "travel" },
  dispensary: { demo: "/dispensaries", word: "dispensary" },
};

const SERVICE_CATEGORIES = CATEGORY_ORDER.map(key => {
  const preset = getCategoryPreset(key);
  const meta = DEMO_META[key] || {};
  return {
    id: key,
    word: meta.word || preset.name.toLowerCase(),
    icon: preset.icon,
    iconColor: preset.iconColor,
    bgColor: preset.bgColor,
    demo: meta.demo || null,
  };
});

export default function AllCategoriesSection({ currentCategory = null }) {
  return (
    <section className="py-12 sm:py-16 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl sm:text-2xl font-bold text-center text-gray-900 mb-6 sm:mb-8">
          Built for every service industry
        </h2>
        <div className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-11 gap-2 sm:gap-3">
          {SERVICE_CATEGORIES.map((item, i) => {
            const isCurrent = item.id === currentCategory;
            
            const content = (
              <div 
                className={`p-2 sm:p-3 rounded-xl ${isCurrent ? 'ring-2' : ''} hover:shadow-md transition-all text-center relative ${item.demo && !isCurrent ? 'cursor-pointer' : ''}`}
                style={{ backgroundColor: item.bgColor, ...(isCurrent ? { ringColor: item.iconColor } : {}) }}
              >
                <item.icon className="w-4 h-4 sm:w-5 sm:h-5 mx-auto mb-1 sm:mb-1.5" style={{ color: item.iconColor }} />
                <p className="text-[9px] sm:text-xs font-semibold truncate" style={{ color: item.iconColor }}>{item.word}</p>
              </div>
            );
            
            return item.demo && !isCurrent ? (
              <Link key={i} to={item.demo}>{content}</Link>
            ) : (
              <div key={i}>{content}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

// Export the categories for use elsewhere
export { SERVICE_CATEGORIES };
